var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('b-card-code', {
    attrs: {
      "title": "Wrap Option"
    },
    scopedSlots: _vm._u([{
      key: "code",
      fn: function fn() {
        return [_vm._v(" " + _vm._s(_vm.codeWrap) + " ")];
      },
      proxy: true
    }])
  }, [_c('b-card-text', [_c('span', [_vm._v("To disable carousel slide wrapping, set the ")]), _c('code', [_vm._v("no-wrap")]), _c('span', [_vm._v(" prop to true.")])]), _c('b-carousel', {
    attrs: {
      "id": "carousel-interval",
      "no-wrap": "",
      "controls": "",
      "indicators": "",
      "interval": 400
    }
  }, [_c('b-carousel-slide', {
    attrs: {
      "img-src": require('@/assets/images/slider/01.jpg')
    }
  }), _c('b-carousel-slide', {
    attrs: {
      "img-src": require('@/assets/images/slider/02.jpg')
    }
  }), _c('b-carousel-slide', {
    attrs: {
      "img-src": require('@/assets/images/slider/04.jpg')
    }
  })], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }